import { showRequestError } from '../../utils/request-feedback';
import { PermissionControl } from '../../permissions/access';
import { useEffect, useState } from 'react'
import { Button, Popconfirm, Table, Pagination, Typography, Tooltip, Tag, Space, Image, Flex } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { message } from 'antd';
import { deleteCourseModuleCategory, fetchCourseModuleCategories, updateCourseModuleCategory } from '../../api/learning';
import CategoryEditModalView from './category_edit_modal_view';

const CourseModuleCategoryView = ({ moduleId }) => {
    const [tabData, setTabData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [currCategory, setCurrCategory] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    const tabCols = [
        {
            title: 'Index',
            dataIndex: 'index',
            key: 'index',
            render: (text, _, index) => ((pageNum - 1) * pageSize + index + 1)
        },
        {
            title: 'Icon',
            dataIndex: 'icon',
            key: 'icon',
            render: (text, _) => {
                return <Image preview={false} width={32} height={32} src={text} />;
            },
        },
        {
            title: 'Course Category',
            dataIndex: 'category',
            key: 'category',
            render: (_, record) => {
                const { category } = record;
                return <Tag>{category.name}</Tag>
            },
        },
        {
            title: 'Site',
            dataIndex: 'site',
            key: 'site',
            render: (text, _) => {
                return <b>{text}</b>
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, _) => {
                if (String(text) === '0') return <Tag color='success'>Active</Tag>;
                return <Tag color='warning'>Inactive</Tag>
            },
        },
        {
            title: 'CreatedAt',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text, _) => {
                return <label style={{ fontSize: 12, color: '#afafaf' }}>{dayjs(text).format('YYYY-MM-DD HH:mm')}</label>
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record, index) => {
                return (
                    <Button.Group size='small'>
                        <PermissionControl permission="learningcenter.control.editHandle.a53c7943"><Button type='link' onClick={() => { editHandle(record) }}>Edit</Button></PermissionControl>
                        <PermissionControl permission="learningcenter.control.activeHandle.4d84102e"><Button type='link' onClick={() => { activeHandle(record) }}>{String(record.status) === '0' ? 'Inactive' : 'Active'}</Button></PermissionControl>
                        <PermissionControl permission="learningcenter.control.deleteHandle.abb0c3fc"><Popconfirm
                            title="Delete Action"
                            description="Are you sure to delete this category?"
                            onConfirm={() => { deleteHandle(record) }}
                            okText="Yes"
                            cancelText="No" >
                            <Button danger type='link'>Delete</Button>
                        </Popconfirm></PermissionControl>
                    </Button.Group>
                )
            }
        }
    ];

    useEffect(() => {
        getModuleCategories(pageNum, pageSize);
    }, [])

    const getModuleCategories = (pNum, pSize) => {
        setLoading(true);

        let params = {
            'page.num': pNum,
            'page.size': pSize,
            moduleId
        }
        fetchCourseModuleCategories(params).then(res => {
            if (res.list) {
                setTabData(res.list);
            }
            if (res.page) {
                setTotal(res.page.total);
            }
        }).finally(() => setLoading(false)).catch(showRequestError)
    }

    const pageChange = (page, size) => {
        setPageNum(page);
        setPageSize(size);
        getModuleCategories(page, size);
    }

    const activeHandle = (record) => {
        setLoading(true);
        updateCourseModuleCategory({ id: record.id, status: record.status === 1 ? 0 : 1 }).then(res => {
            if (res) {
                getModuleCategories(pageNum, pageSize);
            }
        }).finally(() => {
            setLoading(false);
        }).catch(showRequestError)
    }

    const editHandle = (record) => {
        setCurrCategory(record);
        setModalOpen(true);
    }

    const addCategory = () => {
        setCurrCategory(null);
        setModalOpen(true);
    }

    const deleteHandle = (record) => {
        setLoading(true);
        deleteCourseModuleCategory(record.id).then(res => {
            if (res) {
                message.success('deleted!');
                getModuleCategories(pageNum, pageSize);
            }
        }).catch(err => {
            showRequestError(err, err?.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <div className='main-wrapper'>
            <Flex className='top-part cnt-item' justify='flex-end'>
                <PermissionControl permission="learningcenter.control.button.97e493b4"><Button type='primary' icon={<PlusOutlined />} onClick={addCategory}>Add New Category</Button></PermissionControl>
            </Flex>
            <div className='cnt-item'>
                <Table loading={loading} rowKey={(record) => record.id} rowClassName={'table-row'} size='small' dataSource={tabData} columns={tabCols} pagination={false} />
            </div>
            <div className='footer-part cnt-item'>
                <Pagination
                    total={total}
                    showTotal={(total) => `total ${total}`}
                    current={pageNum}
                    pageSize={pageSize}
                    showSizeChanger={true}
                    pageSizeOptions={[10, 20, 30, 50]}
                    onChange={(page, size) => pageChange(page, size)}
                />
            </div>

            <CategoryEditModalView
                moduleId={moduleId}
                open={modalOpen}
                defaultCategory={currCategory}
                onClose={() => setModalOpen(false)}
                onUpdate={() => {
                    getModuleCategories(pageNum, pageSize);
                }}
            />
        </div>
    )
}

export default CourseModuleCategoryView;